import { ArrowLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  Row,
  Space,
  Switch,
  Table,
  theme,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Heading from "../../../../components/common/heading";
import {
  DATA_MASTER_DATA_TYPE,
  PERMISSION,
  SUCCESS_CODE,
} from "../../../../lib/const";
import useCancelModal from "../../../../lib/hooks/useCancelModal";
import useMasterData from "../../../../lib/hooks/useMasterData";
import { routes } from "../../../../routes";
import { getRoleId } from "../../../../services/userManagement";
import WithSidebar from "../../../../templates/withSidebar";
import "../../style.css";

const { Panel } = Collapse;
const { TextArea } = Input;

const Options = {
  create: "สร้าง",
  edit: "แก้ไข",
  delete: "ลบ",
  watch: "ดู",
  export: "Export JPG",
};

const appOptions = {
  create: "สร้าง",
  edit: "แก้ไข",
  delete: "ลบ",
  watch: "ดู",
  export: "Export Excel",
};

const applicationOptions = [
  appOptions.create,
  appOptions.edit,
  appOptions.delete,
  appOptions.watch,
  appOptions.export,
];

const CheckboxGroup = Checkbox.Group;
const plainOptions = [
  Options.create,
  Options.edit,
  Options.delete,
  Options.watch,
];
const dashboardOptions = [Options.watch, Options.export];

const panelStyle = {
  marginBottom: 24,
  // background: "#EBF5FF",
  borderRadius: "16px",
  border: "none",
};

const ViewUserRoleManagement = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { token } = theme.useToken();
  const { setOpenCancelModal } = useCancelModal();
  const [permissions] = useMasterData(DATA_MASTER_DATA_TYPE, PERMISSION);

  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openFailModal, setOpenFailModal] = useState(false);

  //กรอกผ่าน Application
  const [checkedListApp1, setCheckedListApp1] = useState([]);
  const [checkedListApp2, setCheckedListApp2] = useState([]);
  const [checkedListApp3, setCheckedListApp3] = useState([]);
  const [checkedListApp4, setCheckedListApp4] = useState([]);
  const [checkAllApp1, setCheckAllApp1] = useState(false);
  const [checkAllApp2, setCheckAllApp2] = useState(false);
  const [checkAllApp3, setCheckAllApp3] = useState(false);
  const [checkAllApp4, setCheckAllApp4] = useState(false);
  const [checkAllEstate1, setCheckAllEstate1] = useState(false);
  const [indeterminateApp1, setIndeterminateApp1] = useState(false);
  const [indeterminateApp2, setIndeterminateApp2] = useState(false);
  const [indeterminateApp3, setIndeterminateApp3] = useState(false);
  const [indeterminateApp4, setIndeterminateApp4] = useState(false);
  const [viewApp5, setViewApp5] = useState(false);
  const [viewApp6, setViewApp6] = useState(false);
  const [createEditApp5, setCreateEditApp5] = useState(false);
  const [createEditApp6, setCreateEditApp6] = useState(false);
  const [allYearOfBudgetApp5, setAllYearOfBudgetApp5] = useState(false);
  const [allYearOfBudgetApp6, setAllYearOfBudgetApp6] = useState(false);
  const [checkExportPDFApp7, setCheckExportPDFApp7] = useState(false);
  const [checkExportPDFApp8, setCheckExportPDFApp8] = useState(false);

  //นำเข้าข้อมูล Raw Data
  const [checkedListRawData1, setCheckedListRawData1] = useState([]);
  const [checkedListRawData2, setCheckedListRawData2] = useState([]);
  const [checkAllRawData1, setCheckAllRawData1] = useState(false);
  const [checkAllRawData2, setCheckAllRawData2] = useState(false);
  const [indeterminateRawData1, setIndeterminateRawData1] = useState(false);
  const [indeterminateRawData2, setIndeterminateRawData2] = useState(false);

  //ค้นหา/แก้ไขข้อมูล
  const [checkedListAction1, setCheckedListAction1] = useState([]);
  const [checkedListAction2, setCheckedListAction2] = useState([]);
  const [indeterminateAction1, setIndeterminateAction1] = useState(false);
  const [indeterminateAction2, setIndeterminateAction2] = useState(false);
  const [checkAllAction1, setCheckAllAction1] = useState(false);
  const [checkAllAction2, setCheckAllAction2] = useState(false);

  //Dashboard
  const [checkedListDashboard1, setCheckedListDashboard1] = useState([]);
  const [checkedListDashboard2, setCheckedListDashboard2] = useState([]);
  const [checkedListDashboard3, setCheckedListDashboard3] = useState([]);
  const [checkedListDashboard4, setCheckedListDashboard4] = useState([]);
  const [checkedListDashboard5, setCheckedListDashboard5] = useState([]);
  const [indeterminateDashboard1, setIndeterminateDashboard1] = useState(false);
  const [indeterminateDashboard2, setIndeterminateDashboard2] = useState(false);
  const [indeterminateDashboard3, setIndeterminateDashboard3] = useState(false);
  const [indeterminateDashboard4, setIndeterminateDashboard4] = useState(false);
  const [indeterminateDashboard5, setIndeterminateDashboard5] = useState(false);
  const [checkAllDashboard1, setCheckAllDashboard1] = useState(false);
  const [checkAllDashboard2, setCheckAllDashboard2] = useState(false);
  const [checkAllDashboard3, setCheckAllDashboard3] = useState(false);
  const [checkAllDashboard4, setCheckAllDashboard4] = useState(false);
  const [checkAllDashboard5, setCheckAllDashboard5] = useState(false);

  const [loading, setLoading] = useState(false);
  const [submittable, setSubmittable] = useState(false);
  const values = Form.useWatch([], form);

  const fetchRoleByID = useCallback(
    async (id) => {
      const res = await getRoleId(id);

      if (res?.data?.code === SUCCESS_CODE) {
        const { objectValue } = res.data;

        setDataSource([objectValue]);
        const { authorization } = res?.data.objectValue;

        for (let i = 0; i < authorization.length; i++) {
          if (
            // กรอกผ่าน Application
            authorization[i].authorizeTopicId ===
            "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1"
          ) {
            let arr = [];
            if (authorization[i].authorizeNameTh === "รายงานผลตัวชี้วัด") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "ดู" &&
                  arr[j].isSelected
                ) {
                  setViewApp5(true);
                } else if (
                  arr[j].permissionNameTh === "สร้าง/แก้ไข" &&
                  arr[j].isSelected
                ) {
                  setCreateEditApp5(true);
                } else if (
                  arr[j].permissionNameTh === "เข้าถึงข้อมูลทุกปีงบประมาณ" &&
                  arr[j].isSelected
                ) {
                  setAllYearOfBudgetApp5(true);
                }
              }
            } else  
            if (authorization[i].authorizeNameTh === "รายงานผลการดำเนินงานตามแผนปฏิบัติการ") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "ดู" &&
                  arr[j].isSelected
                ) {
                  setViewApp6(true);
                } else if (
                  arr[j].permissionNameTh === "สร้าง/แก้ไข" &&
                  arr[j].isSelected
                ) {
                  setCreateEditApp6(true);
                } else if (
                  arr[j].permissionNameTh === "เข้าถึงข้อมูลทุกปีงบประมาณ" &&
                  arr[j].isSelected
                ) {
                  setAllYearOfBudgetApp6(true);
                }
              }
            }else  
            if (authorization[i].authorizeNameTh === "รายงานจัดอันดับลูกค้าปัจจุบัน") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "นำออกข้อมูล PDF" &&
                  arr[j].isSelected
                ) {
                  setCheckExportPDFApp7(true);
                }
              }
            }else  
            if (authorization[i].authorizeNameTh === "รายงานจัดอันดับลูกค้าอนาคต") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "นำออกข้อมูล PDF" &&
                  arr[j].isSelected
                ) {
                  setCheckExportPDFApp8(true);
                }
              }
            }
             else  
            if (authorization[i].authorizeNameTh === "ข้อมูลลูกค้าปัจจุบัน") {
              // ข้อมูลลูกค้าปัจจุบัน
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllApp1(checkedAll);
                setCheckedListApp1(applicationOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    console.log(
                      "arr[j].permissionNameTh :: ",
                      arr[j].permissionNameTh
                    );
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp1(chk);
              }

              // loop over arr look for arr[j].permissionNameTh == เข้าถึงข้อมูลทุกนิคมได้
              // if found set checkAllEstate1 = true
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "เข้าถึงข้อมูลทุกนิคมได้" &&
                  arr[j].isSelected
                ) {
                  setCheckAllEstate1(true);
                  break;
                }
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลลูกค้าอนาคต"
            ) {
              //ข้อมูลลูกค้าอนาคต"
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || arr.length - 1 === c_true) {
                setCheckAllApp2(checkedAll);
                setCheckedListApp2(applicationOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp2(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูล Touch Point"
            ) {
              //"ข้อมูล Touch Point"
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllApp3(checkedAll);
                setCheckedListApp3(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp3(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลผู้มีส่วนได้ส่วนเสีย"
            ) {
              // ข้อมูลผู้มีส่วนได้ส่วนเสีย
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllApp4(checkedAll);
                setCheckedListApp4(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp4(chk);
              }
            }
          } else if (
            // นำเข้าข้อมูล Raw Data
            authorization[i].authorizeTopicId ===
            "0dde5e71-42a7-f39c-8d63-1c855b36d07a"
          ) {
            let arr = [];
            if (authorization[i].authorizeNameTh === "ข้อมูลความพึงพอใจ") {
              // ข้อมูลความพึงพอใจ
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllRawData1(checkedAll);
                setCheckedListRawData1(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListRawData1(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูล Master Data"
            ) {
              //ข้อมูล Master Data
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllRawData2(checkedAll);
                setCheckedListRawData2(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListRawData2(chk);
              }
            }
          } else if (
            // ค้นหา / แก้ไขข้อมูล
            authorization[i].authorizeTopicId ===
            "f15f9069-71d0-a6e3-29a7-121206554679"
          ) {
            //
            let arr = [];
            if (authorization[i].authorizeNameTh === "ข้อมูลลูกค้าปัจจุบัน") {
              // ข้อมูลลูกค้าปัจจุบัน
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || arr.length - 1 === c_true) {
                setCheckAllAction1(checkedAll);
                setCheckedListAction1(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListAction1(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลลูกค้าอนาคต"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllAction2(checkedAll);
                setCheckedListAction2(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListAction2(chk);
              }
            }
          } else if (
            // Dashboard
            authorization[i].authorizeTopicId ===
            "b9d77677-8a83-4059-6b91-1ec9b2803acb"
          ) {
            let arr = [];
            if (authorization[i].authorizeNameTh === "ข้อมูลลูกค้าปัจจุบัน") {
              // ข้อมูลลูกค้าปัจจุบัน
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard1(checkedAll);
                setCheckedListDashboard1(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard1(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลลูกค้าอนาคต"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard2(checkedAll);
                setCheckedListDashboard2(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard2(chk);
              }
            } else if (authorization[i].authorizeNameTh === "Customer Visit") {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard3(checkedAll);
                setCheckedListDashboard3(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard3(chk);
              }
            } else if (
              authorization[i].authorizeNameEn === "Complaint Analysis Report"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard4(checkedAll);
                setCheckedListDashboard4(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard4(chk);
              }
            } else if (
              authorization[i].authorizeNameEn ===
              "Customer Satisfaction Survey"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard5(checkedAll);
                setCheckedListDashboard5(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard5(chk);
              }
            }
          }
        }
      } else {
        setDataSource([]);
      }
    },
    [setDataSource]
  );

  useEffect(() => {
    fetchRoleByID(params.id);
  }, [params.id, fetchRoleByID]);

  const columns = [
    {
      title: "ชื่อ role",
      align: "role_name",
      dataIndex: "roleNameTh",
      key: "roleNameTh",
      width: 200,
    },
    {
      title: "รายละเอียด Role",
      dataIndex: "description",
      key: "description",
      width: 300,
      render: (_, record) => <span>{record.description || "-"}</span>,
    },
    {
      title: "Permission",
      dataIndex: "permissionId",
      key: "permissionId",
      width: 300,
      render: (_, record) => (
        <span>
          {record.permissionId
            ? permissions.map(
                (item) =>
                  item.dataId === record.permissionId && item.dataDetailTh
              )
            : "-"}
        </span>
      ),
    },
    {
      title: "สถานะ Role",
      dataIndex: "status",
      key: "status",

      render: (_, record) => (
        <>
          <Switch
            defaultChecked={record.recStatus === "A" ? true : false}
            onChange={onChangeStatus}
          />
        </>
      ),
    },
  ];

  const onChangeStatus = (checked) => {
    console.log(`switch to ${checked}`);
  };

  return (
    <WithSidebar>
      <div className="view_role_management">
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24} vertical="center">
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: (
                    <Link to={routes.user_management}>การจัดการผู้ใช้งาน</Link>
                  ),
                },

                {
                  title: <span className="pr_green">รายละเอียด</span>,
                },
              ]}
            />
          </Col>

          <Form
            form={form}
            layout="vertical"
            style={{ width: "100%", padding: "0 30px" }}
          >
            <Col span={24}>
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      type="primary"
                      onClick={() =>
                        navigate(
                          routes.edit_user_role_management + `/${params.id}`
                        )
                      }
                    >
                      แก้ไข
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[8]} className="card">
                <Col span={24}>
                  <Heading text={"ชื่อสิทธ์"} size={4} style={{ margin: 0 }} />
                  <Divider />
                </Col>
                <Col span={24}>
                  <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                  />
                </Col>
              </Row>

              <Row gutter={[8]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"สิทธ์การเข้าถึง"}
                    size={4}
                    style={{ margin: 0 }}
                  />
                  <Divider />
                </Col>
                <Col span={24}>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={["1"]}
                    expandIconPosition={"right"}
                    expandIcon={({ isActive }) => (
                      <CaretRightOutlined rotate={isActive ? 90 : 0} />
                    )}
                    style={{
                      background: token.colorBgContainer,
                    }}
                  >
                    <Panel
                      header={
                        <>
                          <span className="box-border"></span>กรอกผ่าน
                          Application
                        </>
                      }
                      key="1"
                      style={panelStyle}
                    >
                      <Row gutter={[24, 18]}>
                        <Col span={24}>
                          <Form.Item label="ข้อมูลลูกค้าปัจจุบัน" name={"app1"}>
                            <CheckboxGroup
                              options={applicationOptions}
                              value={checkedListApp1}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateApp1}
                              checked={checkAllApp1}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                            <Checkbox
                              checked={checkAllEstate1}
                              disabled
                            >
                              เข้าถึงข้อมูลทุกนิคมได้
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item label="ข้อมูลลูกค้าอนาคต" name={"app2"}>
                            <CheckboxGroup
                              options={applicationOptions}
                              value={checkedListApp2}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateApp2}
                              checked={checkAllApp2}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item label="ข้อมูล Touch Point" name={"app3"}>
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedListApp3}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateApp3}
                              checked={checkAllApp3}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="ข้อมูลผู้มีส่วนได้ส่วนเสีย"
                            name={"app4"}
                          >
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedListApp4}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateApp4}
                              checked={checkAllApp4}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="รายงานผลตัวชี้วัด"
                            name={"app5"}
                          >
                            <Checkbox style={{ width: "140px" }}
                              checked={createEditApp5}
                              disabled
                            >
                              สร้าง/แก้ไข
                            </Checkbox>

                            <Checkbox style={{ width: "140px" }}
                              checked={viewApp5}
                              disabled
                            >
                              ดู
                            </Checkbox>

                            <Checkbox 
                              checked={allYearOfBudgetApp5}
                              disabled
                            >
                              เข้าถึงข้อมูลทุกปีงบประมาณ
                            </Checkbox>

                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="รายงานผลการดำเนินงานตามแผนปฏิบัติการ"
                            name={"app5"}
                          >
                            <Checkbox style={{ width: "140px" }}
                              checked={createEditApp6}
                              disabled
                            >
                              สร้าง/แก้ไข
                            </Checkbox>

                            <Checkbox style={{ width: "140px" }}
                              checked={viewApp6}
                              disabled
                            >
                              ดู
                            </Checkbox>

                            <Checkbox 
                              checked={allYearOfBudgetApp6}
                              disabled
                            >
                              เข้าถึงข้อมูลทุกปีงบประมาณ
                            </Checkbox>

                          </Form.Item>
                        </Col>
                        <Col span={24}>
                              <Form.Item
                                label="รายงานจัดอันดับลูกค้าปัจจุบัน"
                                name={"app7"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  checked={checkExportPDFApp7}
                                  disabled
                                >
                                  Export PDF
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานจัดอันดับลูกค้าอนาคต"
                                name={"app8"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  checked={checkExportPDFApp8}
                                  disabled
                                >
                                  Export PDF
                                </Checkbox>
                              </Form.Item>
                            </Col>
                      </Row>
                    </Panel>

                    <Panel
                      header={
                        <>
                          <span className="box-border"></span>นำเข้าข้อมูล Raw
                          Data
                        </>
                      }
                      key="2"
                      style={panelStyle}
                    >
                      <Row gutter={[24, 18]}>
                        <Col span={24}>
                          <Form.Item label="ข้อมูลความพึงพอใจ" name={"raw1"}>
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedListRawData1}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateRawData1}
                              checked={checkAllRawData1}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item label="ข้อมูล Master Data" name={"raw2"}>
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedListRawData2}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateRawData2}
                              checked={checkAllRawData2}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Panel>

                    {/* <Panel
                      header={
                        <>
                          <span className="box-border"></span>ค้นหา /
                          แก้ไขข้อมูล
                        </>
                      }
                      key="3"
                      style={panelStyle}
                    >
                      <Row gutter={[24, 18]}>
                        <Col span={24}>
                          <Form.Item
                            label="ข้อมูลลูกค้าปัจจุบัน"
                            name={"action1"}
                          >
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedListAction1}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateAction1}
                              checked={checkAllAction1}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item label="ข้อมูลลูกค้าอนาคต" name={"action2"}>
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedListAction2}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateAction2}
                              checked={checkAllAction2}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Panel> */}

                    <Panel
                      header={
                        <>
                          <span className="box-border"></span>Dashboard
                        </>
                      }
                      key="4"
                      style={panelStyle}
                    >
                      <Row gutter={[24, 18]}>
                        <Col span={24}>
                          <Form.Item
                            label="ข้อมูลลูกค้าปัจจุบัน"
                            name={"dash1"}
                          >
                            <CheckboxGroup
                              options={dashboardOptions}
                              value={checkedListDashboard1}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateDashboard1}
                              checked={checkAllDashboard1}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item label="ข้อมูลลูกค้าอนาคต" name={"dash2"}>
                            <CheckboxGroup
                              options={dashboardOptions}
                              value={checkedListDashboard2}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateDashboard2}
                              checked={checkAllDashboard2}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item label="Customer Visit" name={"dash3"}>
                            <CheckboxGroup
                              options={dashboardOptions}
                              value={checkedListDashboard3}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateDashboard3}
                              checked={checkAllDashboard3}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Complaint Analysis Report"
                            name={"dash4"}
                          >
                            <CheckboxGroup
                              options={dashboardOptions}
                              value={checkedListDashboard4}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateDashboard4}
                              checked={checkAllDashboard4}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Customer Satisfaction Survey"
                            name={"dash5"}
                          >
                            <CheckboxGroup
                              options={dashboardOptions}
                              value={checkedListDashboard5}
                              disabled
                            />
                            <Checkbox
                              indeterminate={indeterminateDashboard5}
                              checked={checkAllDashboard5}
                              disabled
                            >
                              ทำได้ทั้งหมด
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Panel>
                  </Collapse>
                </Col>
              </Row>
            </Col>
          </Form>
        </Row>
      </div>
    </WithSidebar>
  );
};

export default ViewUserRoleManagement;
